import React, { useEffect, useState } from "react";
import UserWrapper from "../Companies/company.style";
import PageTitle from "components/common/PageTitle";
import UserForm from "components/company/CompanyForm";
import CustomToast from 'components/notifications/CustomToast';
import { connect } from "react-redux";

const UserEdit = props => {
    const [editedData, setEditedData] = useState(null);

    const [formErrors, setFormError] = useState('');
    const [formSuccess, setFormSuccess] = useState('');
    const [topRightDanger, setTopRightDanger] = useState(false);
    const [topRightSuccess, setTopRightSuccess] = useState(false);


    const hasParam = props.match.params.hasOwnProperty("id");
    const { match: { params } } = props
    useEffect(() => {
        if (hasParam) {
            const data = props.location.state
            setEditedData(data);
        }
    }, [params, hasParam]);

    const submitFormHandler = (data, action) => {

        setTopRightDanger(false);
        setTopRightSuccess(false);
        setFormError('');
        setFormSuccess('');


        if (action === "add") {
            fetch('/service/companies', {
                method: 'POST',
                body: JSON.stringify(data),
            })
            .then(res => res.json())
            .then(data => {
                if(data.hasErr) {
                    setTopRightDanger(true)
                    if(data.err === '11000') {
                        setFormError('Bu email ile kayıtlı bir şirket zaten var.')
                    }
                    if(data.err.phone_number){
                        setFormError('Telefon numarasını sayısal olarak girin.')
                    }
                    if(data.err.email){
                        setFormError('Geçersiz email girdiniz.')
                    }
                }else {
                    setTopRightSuccess(true)
                    setFormSuccess('Şirket başarıyla oluşturuldu.')
                }
            });
        } else if (action === "edit") {
            fetch(`/service/companies/${props.location.state._id}`, {
                method: 'PATCH',
                body: JSON.stringify(data),
            }).then(res => res.json())
            .then(data => {
                if(data.hasErr === true) {
                    setTopRightDanger(true)
                    if(data.err === '11000') {
                        setFormError('Bu email ile kayıtlı bir şirket zaten var.')
                    }
                    if(data.err.phone_number){
                        setFormError('Telefon numarasını sayısal olarak girin.')
                    }
                    if(data.err.email){
                        setFormError('Geçersiz email girdiniz.')
                    }
                }else {
                    setTopRightSuccess(true)
                    setFormSuccess('Şirket başarıyla güncellendi.')
                }
            });
        }
    };

    return (
        <UserWrapper {...props}>
            <div className="pos-relative">
                <PageTitle
                    title="companies"
                    className="plr-15"
                    breadCrumb={[
                        {
                            name: "sidebar.dashboard"
                        },
                        {
                            name: "companies"
                        },
                        {
                            name: hasParam ? "action.edit" : "action.add"
                        }
                    ]}
                />
                <div
                    className="back-icon fs-15 demi-bold-text cursor-pointer"
                    onClick={() => props.history.push("/users")}
                >
                    <i className="fas fa-step-backward"></i> Geri Dön
                </div>
            </div>
            <div className="plr-15">
                <div className="roe-card-style mtb-15">
                    <div className="roe-card-header module-header">
                        <div className="flex-1 fs-16 demi-bold-text">
                            <span className="hash"># </span>{" "}
                            Kullanıcı
                            {hasParam ? " Düzenle" : " Ekle"}
                        </div>
                    </div>
                    <div className="roe-card-body">
                        <UserForm
                            onSubmit={submitFormHandler}
                            editedData={editedData}
                            action={hasParam ? "edit" : "add"}
                        />
                    </div>
                </div>
                <CustomToast
                    heading={"Notify!"}
                    width={400}
                    show={topRightSuccess}
                    transition
                    position="top-right"
                    className="c-success"
                    message={formSuccess}
                    onCloseCLick={() =>
                        setTopRightSuccess(false)
                    }
                />
                <CustomToast
                    heading={"Notify!"}
                    width={400}
                    show={topRightDanger}
                    transition
                    position="top-right"
                    className="c-danger"
                    message={formErrors}
                    onCloseCLick={() =>
                        setTopRightDanger(false)
                    }
                />

            </div>
        </UserWrapper>
    );
};

const mapStateToProps = state => {
    return {
        ...state.themeChanger
    };
};

export default connect(
    mapStateToProps,
    null
)(UserEdit);
